// Loads the Google Tag Manager container named by this script tag's data-gtm-id. This is the
// standard GTM snippet, shipped as a classic IIFE bundle from /assets/help-frontend because
// the chat CSP (script-src 'self') forbids the inline snippet Google hands out. Runs in <head>
// before the app, so gtm.js starts downloading as early as the inline snippet used to.

import { mayLoadTagManager, tagManagerScriptUrl } from "./tag-manager.js";

(function loadTagManager(): void {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return;
  }
  const containerId = document.currentScript?.dataset.gtmId?.trim();
  if (!containerId || !mayLoadTagManager(new URL(window.location.href))) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = tagManagerScriptUrl(containerId);
  document.head.appendChild(script);
})();
